<script setup>
import { ref, onMounted } from "vue";
import { RouterLink } from 'vue-router';
import { useServiceStore } from "@/stores/serviceStore";

const storeService = useServiceStore();

onMounted(() => {
	storeService.hideScreenLoader()
});
</script>

<template>
	<div class="services-container">
		<div class="container">
			<h2 class="service-title">Забронировано</h2>
			<div class="service">
				<div class="success">
					<p class="success__text">Текст успеха</p>
					<RouterLink class="success__btn btn --full" to="/">На главную</RouterLink>
				</div>
			</div>
		</div>
	</div>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";

.success {
	max-width: 73rem;
	margin-left: auto;
	margin-right: auto;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}
.success__text {
	font-weight: 400;
	font-size: 2.8rem;
	line-height: 140%;
	text-align: center;
	color: var(--text-inverse-100);
	@media (max-width: vars.$x425) {
		font-size: 1.8rem;
	}
}
.success__btn {
	margin-top: 10rem;
}
</style>
